import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';

const KEY_ENTER = 13;
const KEY_SPACE = 32;

/**
 * Sometimes we want an element to behave exactly like a button however, for a number of
 * reasons, using a button element may not be suitable.
 * FauxButton takes on the role of an HTML button whilst replicating associated browser
 * behaviours.
 */
class _FauxButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    /** Click handler */
    onClick: PropTypes.func.isRequired,
    'aria-haspopup': PropTypes.bool,
    'aria-expanded': PropTypes.bool,
    'aria-controls': PropTypes.string,
    'aria-label': PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.onKeyDown = this.onKeyDown.bind(this);
  }

  onKeyDown(event) {
    if ([KEY_ENTER, KEY_SPACE].indexOf(event.keyCode) !== -1) {
      this.props.onClick(event);
    }
  }

  render() {
    const aria = _.pick(
      this.props,
      'aria-haspopup',
      'aria-expanded',
      'aria-controls',
      'aria-label'
    );

    return (
      <div
        role="button"
        tabIndex="0"
        {...aria}
        onClick={this.props.onClick}
        onKeyDown={this.onKeyDown}
        className={this.props.className}
        children={this.props.children}
      />
    );
  }
}

/** @visibleName Faux Button */
const FauxButton = styled(_FauxButton)`
  cursor: pointer;
`;

/** @component */
export default FauxButton;
